export const SHARED_FOLDER_READ_ONLY_REASON =
    "Shared Knowledge Base folders are read-only.";

export function sharedKnowledgeBaseLabel(groupName: string | null): string {
    return groupName
        ? `${groupName}'s Knowledge Base`
        : "Shared Knowledge Base";
}
